import React, { useState, useEffect, useRef } from 'react';
import { fetchAuthenticatedImage } from '../../../api/services/authService';

const UserAvatar = ({ profilePhotoPath, firstName, lastName }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const blobUrlRef = useRef(null);

  useEffect(() => {
    const loadImage = async () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
        blobUrlRef.current = null;
      }

      if (!profilePhotoPath) {
        setImageUrl(null);
        return;
      }

      if (profilePhotoPath.startsWith('data:') || profilePhotoPath.startsWith('blob:')) {
        setImageUrl(profilePhotoPath);
        return;
      }

      try {
        setLoading(true);
        const blobUrl = await fetchAuthenticatedImage(profilePhotoPath);
        if (blobUrl) {
          blobUrlRef.current = blobUrl;
          setImageUrl(blobUrl);
        } else {
          setImageUrl(null);
        }
      } catch (error) {
        console.error('Failed to load authenticated image:', error);
        setImageUrl(null);
      } finally {
        setLoading(false);
      }
    };

    loadImage();

    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
        blobUrlRef.current = null;
      }
    };
  }, [profilePhotoPath]);

  if (loading) {
    return (
      <div className="user-avatar user-avatar-loading">
        <span>Loading...</span>
      </div>
    );
  }

  if (imageUrl) {
    return (
      <img 
        src={imageUrl} 
        alt={`${firstName || ''} ${lastName || ''}`}
        className="user-avatar"
        onError={() => setImageUrl(null)}
      />
    );
  }

  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';
  return (
    <div className="user-avatar user-avatar-placeholder">
      <span>{initials}</span>
    </div>
  );
};

export default UserAvatar;
